import * as React from 'react';
import { useEffect } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import GroupIcon from '@mui/icons-material/Group';
import { Stack } from '@mui/material';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import block from 'bem-cn';
import { observer } from 'mobx-react';

import { charactersStore } from 'stores';

import Levels from 'pages/MainPage/components/Levels/Levels';
import CharactersList from 'pages/MainPage/components/CharactersList/CharactersList';

import Gestures from './Gestures/Gestures';

import './Modal.scss';

const cnModal = block('Modal');

function Modal({ title, anchor, type, icon, className, event }: any) {
    const [open, setOpen] = React.useState(false);

    const toggleDrawer = (newOpen: boolean) => () => {
        setOpen(newOpen);
        if (event) event();
    };

    useEffect(() => {
        if (open && charactersStore.characters.length === 0 && type !== 'Gestures') {
            charactersStore.getCharacters();
        }
    }, [open]);

    const DrawerList = (
        <Box sx={{ width: '60rem' }} role="presentation">
            <CloseIcon className="closeicon" onClick={() => setOpen(false)} />
            <List sx={{ paddingTop: 0 }}>
                <div className={cnModal()}>
                    <Box className={cnModal('pageContent').toString()}>
                        <Stack className={cnModal('charactersList').toString()}>
                            <CharactersList dynamic={true} />
                        </Stack>
                        <Stack className={cnModal('Levels').toString()}>
                            <Levels dynamic={true} setOpen={setOpen} />
                        </Stack>
                    </Box>
                </div>
            </List>
        </Box>
    );

    return (
        <>
            <div className={className} onClick={toggleDrawer(true)}>
                {icon ?? <GroupIcon />} {title ?? 'Настройки'}
            </div>
            <Drawer open={open} anchor={anchor ?? 'left'} onClose={toggleDrawer(false)}>
                {type === 'Gestures' ? <Gestures setOpen={setOpen} /> : DrawerList}
            </Drawer>
        </>
    );
}

export default observer(Modal);
